var React = require('react');

function Briefcase (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M 9.6002287,16.799542 V 15.599657 H 1.2010291 v 4.799542 c 0,1.331873 1.0678983,2.399772 2.3997713,2.399772 H 20.399199 c 1.331873,0 2.399772,-1.067899 2.399772,-2.399772 v -4.799542 h -8.399199 v 1.199885 z M 21.599085,6.0005717 H 16.799542 V 3.6008004 L 14.399772,1.2010291 H 9.6002287 L 7.2004574,3.6008004 V 6.0005717 H 2.4009148 c -1.3198742,0 -2.39977132,1.0798971 -2.39977132,2.3997713 V 12 c 0,1.331873 1.06789832,2.399772 2.39977132,2.399772 H 9.6002287 V 12 h 4.7995433 v 2.399772 h 7.199313 c 1.319874,0 2.399772,-1.079898 2.399772,-2.399772 V 8.400343 c 0,-1.3198742 -1.079898,-2.3997713 -2.399772,-2.3997713 z m -7.199313,0 H 9.6002287 V 3.6008004 h 4.7995433 z","style":{"strokeWidth":"1.19989"}}));
}

Briefcase.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Briefcase;

Briefcase.default = Briefcase;
